/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import { IModuleProps, INodeProps } from '@msdyn365-commerce-modules/utilities';
import classnames from 'classnames';
import * as React from 'react';

import { IObrienSlideContainerConfig, IObrienSlideContainerProps } from './obrien-slide-container.props.autogenerated';


export interface IObrienSlideContainerViewProps extends IObrienSlideContainerProps<IObrienSlideContainerConfig> {
    slcategories: React.ReactNode[];
    SlideList: IModuleProps;
    SlideListItem: INodeProps;

    ctcategories: React.ReactNode[];
    ContentList: IModuleProps;
    ContentListItem: INodeProps;

    classNames: string;
}


/**
 *
 * ObrienSlideContainer component.
 * @extends {React.PureComponent<IObrienSlideContainerProps<IObrienSlideContainerConfig>>}
 */
 class ObrienSlideContainer extends React.PureComponent<IObrienSlideContainerProps<IObrienSlideContainerConfig>> {
    public render(): JSX.Element | null {
        const { config } = this.props;

        
        const ClassNames = config.classNames ? config.classNames : '';

        
        const viewprops = {
            ...this.props,
            
            classNames: ClassNames,
            
            slcategories: this.props.slots.slideSlot,
            SlideList: {
                moduleProps: this.props,
                className: classnames('slide__list', this.props.config.className),
                tag: 'div'
            },
            SlideListItem: {
                className: classnames('slide__list-item', this.props.config.className),
                tag: 'div'
            },

            ctcategories: this.props.slots.contentSlot,
            ContentList: {
                moduleProps: this.props,
                className: classnames('content__list', this.props.config.className),
                tag: 'div'
            },
            ContentListItem: {
                className: classnames('content__list-item text-left', this.props.config.className),
                tag: 'div'
            }
        };

       

        return this.props.renderView(viewprops) as React.ReactElement;
        
    }
}

export default ObrienSlideContainer;
